import React from 'react';
import update from 'react-addons-update';
import PropTypes from 'prop-types';
import { Form, Input, Col } from 'reactstrap';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../assets/styles/style.sass';
import s2 from '../components/Login/login.sass';
import setting from '../assets/default/setting/general/setting.json';
import RegisterButton from '../components/Login/LoginButton/RegisterButton';
import LoginButton from '../components/Login/LoginButton/LoginButton';
import LoginFacebook from '../components/Login/LoginButton/LoginFacebook';
import { returnLocaleText } from '../service/util';
import { ErrorLink } from '../signup/signup.component.styles';
import { getTranslation } from '../service/asset-json';

import {
  login,
  setUserName,
  setUserEmail,
  setUserPhone,
  setUserPassword,
  setHaveAgreedToReceiveGogovanUpdates,
  setHaveAgreedToReceiveThirdPartiesUpdates,
} from '../actions/user';

class SignupForm extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    has_agreed_to_receive_gogovan_updates: PropTypes.bool.isRequired,
    has_agreed_to_receive_third_parties_updates: PropTypes.bool.isRequired,
    setUserName: PropTypes.func.isRequired,
    setUserEmail: PropTypes.func.isRequired,
    setUserPhone: PropTypes.func.isRequired,
    setHaveAgreedToReceiveGogovanUpdates: PropTypes.func.isRequired,
    setHaveAgreedToReceiveThirdPartiesUpdates: PropTypes.func.isRequired,
    onSignup: PropTypes.func,
  };

  static defaultProps = {
    onSignup: () => {},
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      user: {
        email: '',
        phone: '',
        name: '',
        password_1: '',
        password_2: '',
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: require(`../assets/json/default/setting/general/locale.json`),
      modelDataLocale: require(`../assets/json/${lang}/${fileLang}setting/general/locale.json`),
      errorMessageLocale: require(`../assets/src/${lang}/scripts/components/setting.json`),
    };

    this.getEmail = this.getEmail.bind(this);
    this.getPassword = this.getPassword.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setPhone = this.setPhone.bind(this);
    this.setName = this.setName.bind(this);
    this.tooltipToggle = this.tooltipToggle.bind(this);
    this.setErrorCode = this.setErrorCode.bind(this);
    this.updateStateItem = this.updateStateItem.bind(this);
    this.onClickisClickButton = this.onClickisClickButton.bind(this);
  }

  componentWillMount() {
    if (this.props.currentLocale === 'en-SG') {
      this.props.setHaveAgreedToReceiveGogovanUpdates();
      this.props.setHaveAgreedToReceiveThirdPartiesUpdates();
    }
  }

  // Add custome Validation String
  componentWillUpdate(nextProps, nextState) {
    if (nextState.isClickButton) {
      const email = document.getElementById('email');
      const phone = document.getElementById('phone');
      const name = document.getElementById('name');
      const password1 = document.getElementById('password_1');
      const password2 = document.getElementById('password_2');
      const errorMessage = this.state.errorMessageLocale[
        this.props.currentLocale
      ];
      const emailPatt = new RegExp(this.state.errorMessageLocale.EMAIL_REGEX);
      if (
        email.value === '' ||
        email.value === null ||
        !emailPatt.test(email.value)
      ) {
        email.setCustomValidity(errorMessage.incorrect_email);
        this.setErrorCode(0);
      } else {
        email.setCustomValidity('');
      }

      if (phone.value === '') {
        this.setErrorCode(0);
        phone.setCustomValidity(errorMessage.blank_field);
      } else {
        phone.setCustomValidity('');
      }

      if (name.value === '') {
        this.setErrorCode(0);
        name.setCustomValidity(errorMessage.blank_field);
      } else {
        name.setCustomValidity('');
      }

      if (password1.value === '') {
        this.setErrorCode(0);
        password1.setCustomValidity(errorMessage.blank_field);
      } else {
        password1.setCustomValidity('');
      }

      if (password2.value === '') {
        this.setErrorCode(0);
        password2.setCustomValidity(errorMessage.blank_field);
      } else {
        password2.setCustomValidity('');
      }
      this.onClickisClickButton();
    }
  }

  onClickisClickButton() {
    this.setState({ isClickButton: !this.state.isClickButton });
  }

  setPassword(e) {
    this.updateStateItem(e.target.id, e.target.value);
  }
  setPhone(e) {
    this.updateStateItem('phone', e.target.value);
    this.props.setUserPhone(e.target.value);
  }
  setName(e) {
    this.updateStateItem('name', e.target.value);
    this.props.setUserName(e.target.value);
  }

  setErrorCode(code) {
    this.setState({ errorCode: code });
  }

  getEmail() {
    return this.state.email;
  }

  setEmail(e) {
    this.updateStateItem('email', e.target.value);
    this.props.setUserEmail(e.target.value);
  }

  getPassword() {
    return this.state.password;
  }

  updateStateItem(item, value) {
    this.setState({
      user: update(this.state.user, { [item]: { $set: value } }),
    });
  }

  tooltipToggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    const { currentLocale } = this.props;

    let errorMessage;
    switch (this.state.errorCode) {
      case 1:
        errorMessage = getTranslation('error_message_password_length_not_enough', currentLocale);
        break;
      case 2:
        errorMessage = getTranslation('error_message_password_not_match', currentLocale);
        break;
      case 4:
        errorMessage = getTranslation('error_message_please_enter_telephone_number', currentLocale);
        break;
      case 6:
        errorMessage = getTranslation('error_message_email_used_error_tag_t', currentLocale);
        break;
      case 7:
        errorMessage = getTranslation('error_message_telephone_number_in_use', currentLocale);
        break;
      case 13:
        errorMessage = getTranslation('error_message_email_used_error_tag_t', currentLocale);
        break;
      case 401:
        errorMessage = getTranslation('error_message_login_info_incorrect', currentLocale);
        break;
      default:
        errorMessage = getTranslation('error_wrong_modal_title', currentLocale);
    }

    const showLoginLink = this.state.errorCode === 6 || this.state.errorCode === 13;

    return (
      <div>
        {this.state.errorCode !== 0 && (
          <div className={s2.error}>
            {errorMessage}
            {showLoginLink && (
              <div>
                {getTranslation('error_message_email_used_error_tag_t_2', currentLocale)}
                <ErrorLink href="/login" tabIndex={0}>
                  {getTranslation('login_modal_login_btn', currentLocale)}
                </ErrorLink>
              </div>
            )}
          </div>
        )}
        <h2 className={s2.registerTitle}>
          {returnLocaleText(
            this.state.modelDataLocale.register_modal_title,
            this.state.modelDataDefaultLocale.register_modal_title,
          )}
        </h2>
        <Form
          className={`${s.loginForm}`}
          data-type="login"
          action=""
          onSubmit={e => {
            e.preventDefault();
            return false;
          }}
          method="post"
        >
          <div>
            <input
              className={s2.input}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}"
              type="email"
              placeholder={returnLocaleText(
                this.state.modelDataLocale.register_modal_email_input,
                this.state.modelDataDefaultLocale.register_modal_email_input,
              )}
              id="email"
              name="email"
              value={this.state.user.email}
              onChange={this.setEmail}
              ref={i => {
                this.emailInput = i;
              }}
              required
            />
          </div>
          <div>
            <input
              className={s2.input}
              type="text"
              id="name"
              name="name"
              placeholder={returnLocaleText(
                this.state.modelDataLocale.register_modal_username_input,
                this.state.modelDataDefaultLocale.register_modal_username_input,
              )}
              value={this.state.user.name}
              onChange={this.setName}
              required
            />
          </div>
          <div>
            <input
              className={s2.input}
              type="text"
              id="phone"
              name="phone"
              placeholder={returnLocaleText(
                this.state.modelDataLocale.register_modal_phone_input,
                this.state.modelDataDefaultLocale.register_modal_phone_input,
              )}
              value={this.state.user.phone}
              onChange={this.setPhone}
              required
            />
          </div>
          <div>
            <input
              className={s2.input}
              placeholder={returnLocaleText(
                this.state.modelDataLocale.register_modal_password_input,
                this.state.modelDataDefaultLocale.register_modal_password_input,
              )}
              id="password_1"
              name="password"
              type="password"
              value={this.state.user.password}
              onChange={this.setPassword}
              required
            />
          </div>
          <div>
            <input
              className={s2.input}
              placeholder={returnLocaleText(
                this.state.modelDataLocale
                  .register_modal_confirm_password_input,
                this.state.modelDataDefaultLocale
                  .register_modal_confirm_password_input,
              )}
              id="password_2"
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.setPassword}
              required
            />
          </div>
          {this.props.currentLocale === 'en-SG'
            ? [
                <Col
                  key="0"
                  md={{ size: 8, offset: 2 }}
                  sm={{ size: 8, offset: 2 }}
                  xs={{ size: 12 }}
                  className={`${s2.inputPadding}`}
                >
                  <p className={s2.pdpa}>
                    <Input
                      type="checkbox"
                      onChange={() => {
                        this.props.setHaveAgreedToReceiveGogovanUpdates();
                      }}
                      checked={this.props.has_agreed_to_receive_gogovan_updates}
                    />
                    { getTranslation('register_checkbox_gogovan_updates', currentLocale) }
                  </p>
                </Col>,
                <Col
                  key="1"
                  md={{ size: 8, offset: 2 }}
                  sm={{ size: 8, offset: 2 }}
                  xs={{ size: 12 }}
                  className={s2.inputPadding}
                >
                  <p className={s2.pdpa}>
                    <Input
                      type="checkbox"
                      onChange={() => {
                        this.props.setHaveAgreedToReceiveThirdPartiesUpdates();
                      }}
                      checked={
                        this.props.has_agreed_to_receive_third_parties_updates
                      }
                    />
                    { getTranslation('register_checkbox_third_parties_updates', currentLocale) }
                  </p>
                </Col>,
                <Col
                  key="2"
                  md={{ size: 8, offset: 2 }}
                  sm={{ size: 8, offset: 2 }}
                  xs={{ size: 12 }}
                  className={s2.inputPadding}
                >
                  <span
                    className={s2.pdpa}
                    dangerouslySetInnerHTML={{
                      __html: returnLocaleText(
                        this.state.modelDataLocale.register_info_gogovan_tos,
                        this.state.modelDataDefaultLocale
                          .register_info_gogovan_tos,
                      ),
                    }}
                  />
                </Col>,
              ]
            : ''}
          <div>
            {setting.login_facebook ? (
              <div>
                <RegisterButton
                  className="button register"
                  user={this.state.user}
                  onClickisClickButton={this.onClickisClickButton}
                  tooltipToggle={this.tooltipToggle}
                  setErrorCode={this.setErrorCode}
                  toggle={this.props.onSignup}
                  getEmail={this.getEmail}
                  getPassword={this.getPassword}
                  password_1={this.state.user.password_1}
                  password_2={this.state.user.password_2}
                  text={returnLocaleText(
                    this.state.modelDataLocale.register_modal_register_btn,
                    this.state.modelDataDefaultLocale
                      .register_modal_register_btn,
                  )}
                />
                <LoginFacebook
                  tooltipToggle={this.tooltipToggle}
                  setErrorCode={this.setErrorCode}
                  toggle={this.props.onSignup}
                  getEmail={this.getEmail}
                  getPassword={this.getPassword}
                  text={returnLocaleText(
                    this.state.modelDataLocale.login_modal_login_with_fb_btn,
                    this.state.modelDataDefaultLocale
                      .login_modal_login_with_fb_btn,
                  )}
                />
              </div>
            ) : (
              <LoginButton />
            )}
          </div>
        </Form>
      </div>
    );
  }
}

const mapState = state => ({
  email: state.user.email,
  password: state.user.password,
  has_agreed_to_receive_gogovan_updates:
    state.user.has_agreed_to_receive_gogovan_updates,
  has_agreed_to_receive_third_parties_updates:
    state.user.has_agreed_to_receive_third_parties_updates,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  login,
  setUserName,
  setUserEmail,
  setUserPhone,
  setUserPassword,
  setHaveAgreedToReceiveGogovanUpdates,
  setHaveAgreedToReceiveThirdPartiesUpdates,
};

const ConnectedSignupForm = connect(mapState, mapDispatch)(
  withStyles(s, s2)(SignupForm),
);

export { ConnectedSignupForm, SignupForm };



// WEBPACK FOOTER //
// ./src/signup-form/signup-form.component.js